export default [
  {
    pages: "Homepage",
    featurename: "Search",
    type: "Pre-built",
    extension: "CRM",
    notes: "Search based on cloth categories"
  },
  {
    pages: "Product",
    featurename: "Slider",
    type: "Custom",
    extension: "Whatsapp Bot",
    notes: "component that provides navigational pagination"
  },
  {
    pages: "Homepage",
    featurename: "Footer",
    type: "Extension",
    extension: "Marketing Automation",
    notes: "For controlling in page component pagination"
  },
  {
    pages: "Product",
    featurename: "Navbar",
    type: "Pre-built",
    extension: "SCM",
    notes: "Pages are numbers from 1 through to number-of-pages"
  }
];
